/*
 * @Description: 全局变量
 * @Author: HangerZou
 * @Date: 2021-11-23 13:41:22
 */
const host = 'localhost:8080'
const isNewTemplate = true

export default {
  host, //地址
  isNewTemplate //位置
}
